export default class AccountDrawerAction {
  constructor({ event, text, type }) {
    this.event = event;
    this.text = text;
    this.type = type;
  }
}
